"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function omg(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12.2122 13.4501L10.6897 9.2516H9.3945V14.7439H10.3282V10.8746L11.7412 14.7439H12.6592L14.0707 10.8746V14.7439H15.0277V9.2516H13.734L12.2122 13.4501ZM5.92274 9.1181C4.23674 9.1181 3.16949 10.3894 3.16949 12.0019C3.16949 13.6136 4.23674 14.8819 5.92274 14.8819C7.60875 14.8819 8.67825 13.6226 8.67825 12.0019C8.67825 10.3804 7.611 9.1181 5.92199 9.1181H5.92274ZM5.92274 13.9054C4.84799 13.9054 4.20524 13.0969 4.20524 12.0056C4.20524 10.9136 4.84799 10.0999 5.92274 10.0999C6.99749 10.0999 7.64249 10.9159 7.64249 12.0019C7.64249 13.0871 6.99899 13.9054 5.92274 13.9054ZM18.273 12.7451H19.8495C19.7565 13.5461 19.1745 13.9226 18.429 13.9226C17.3617 13.9226 16.767 13.1374 16.767 12.0071C16.767 10.9474 17.2912 10.0774 18.4065 10.0774C19.1355 10.0774 19.725 10.4494 19.788 11.0741H20.8305C20.6895 9.8186 19.7317 9.1196 18.438 9.1196C16.6012 9.1196 15.7455 10.5326 15.7455 12.0386C15.7455 13.6564 16.7355 14.8796 18.273 14.8796C19.1745 14.8796 19.6785 14.4626 19.881 14.1101V14.7379H20.8305V11.8009H18.273V12.7459V12.7451Z", fill: color }));
}
exports["default"] = omg;
//# sourceMappingURL=omg.js.map